import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import {
  setShow as setModalShow,
  setOrderId,
  setNpsUrl,
} from '~features/modals/ducks';

import { basePath as projectsPath } from '../../projects/ducks';

import Home from '~components/Home';

// Route for email links which opens up a modal and redirects
const NotificationsRoute = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const notifications = useSelector(state => state.user.notifications);
  const { notificationId: notificationIdStr } = useParams();

  useEffect(() => {
    if (notificationIdStr) {
      const notificationId = parseInt(notificationIdStr, 10);
      const notification = notifications?.find(n => n.id === notificationId);

      if (notification) {
        const { npsUrl, orderId, projectId } = notification.details;
        if (orderId) dispatch(setOrderId(orderId));
        if (npsUrl) dispatch(setNpsUrl(npsUrl));
        if (notification.action === 'EVENT_TYPE_PROJECT_INFO') {
          navigate(`${projectsPath}/${projectId}`);
        } else {
          dispatch(
            setModalShow(npsUrl ? 'EXTERNAL_FEEDBACK' : 'ORDER_FEEDBACK')
          );
          navigate('/');
        }
      }
    }
  }, [notificationIdStr]);

  return <Home />;
};

export default NotificationsRoute;
